import { ContainerModule } from 'inversify';
import Tracker from '@framework/analytics-tracker/Tracker';
import DataroomTracker from '@/dataroom/app/AnalyticsTracker/DataroomTracker';

export const analyticsModule: ContainerModule = new ContainerModule(({ bind }) => {
  bind(DataroomTracker).toSelf().inSingletonScope();
  bind(Tracker).toDynamicValue(({ get }) => get(DataroomTracker)).inSingletonScope();
});
